/* eslint-disable no-confusing-arrow */
import dayjs from 'dayjs';

import { converseMaterialOrProductUnit } from '../functions/converseMaterialOrProductUnit';
import { MATERIAL_PURCHASE_STATUS } from '../constants';

const columns = [
  {
    label: 'ลำดับที่',
    value: 'index',
  },
  {
    label: 'วันที่',
    value: (row) => `${dayjs(row?.createdAt)?.format('D/M/BBBB')}`,
  },
  {
    label: 'เวลา',
    value: (row) => `${dayjs(row?.createdAt)?.format('HH:mm')}`,
  },
  {
    label: 'รหัสคู่ค้า',
    value: (row) => row?.supplier?.type_code,
  },

  {
    label: 'คู่ค้า',
    value: (row) => row?.supplier?.name,
  },
  {
    label: 'รหัสวัตถุดิบ',
    value: (row) => row?.material?.type_code,
  },
  {
    label: 'วัตถุดิบ',
    value: (row) => row?.material?.name,
  },
  {
    label: 'จำนวน',
    value: (row) => row?.quantity,
  },
  {
    label: 'หน่วย',
    value: (col) =>
      col?.material?.use_unit_conversion
        ? col?.material?.unit_input?.short_sign
        : col?.material?.unit,
  },
  {
    label: 'คงเหลือ (หน่วยที่สอง)',
    value: (col) =>
      col?.material?.use_unit_conversion
        ? converseMaterialOrProductUnit(col?.material, col?.quantity)
        : '-',
  },
  {
    label: 'หน่วย',
    value: (col) =>
      col?.material?.use_unit_conversion
        ? col?.material?.unit_output?.short_sign
        : '-',
  },
  {
    label: 'สถานะ',
    value: (row) => MATERIAL_PURCHASE_STATUS[row?.status]?.description,
  },
];

export default { columns };
